module.exports = __webpack_public_path__ + "assets/img/slack-logo.c3fe6a2a.png";